import React, { useState, useEffect } from "react";
import "./ProductInnovations.css";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  submitCorporateAndOrgStructureFailure,
  submitCorporateAndOrgStructureRequest,
} from "../../../../store/features/actions/corporateAndOrgStructureActions";
import {
  getAllSubdimensionMatches,
  getAllPageInsights,
} from "../../../../services/commonService";
import PortfolioComposition from "./PortfolioComposition";
import FeaturesDifferentiators from "./FeaturesDifferentiators";
import PerformanceAdoption from "./PerformanceAdoption";
import PatentPortfolio from "./PatentPortfolio";
import PatentLicensingCollaborations from "./PatentLicensingCollaborations";
import LaunchTimelinesRegions from "./LaunchTimelinesRegions";
import AdoptionMarketResponse from "./AdoptionMarketResponse";
import TopRightActionLinks from "../TopRightActionLinks";
import InsightBlock from "../InsightBlock";
import GenericOverviewSideCard from "../../genericComponents/GenericOverviewSideCard";
import AIChat from "../../Chat/AiChat";
import GenericTableSkeleton from "../../skeletons/tableSkeleton/genericTableSkeleton";

function ProductInnovations() {
  const { clientName, competitorName } = useParams();
  const [showConversationModal, setShowConversationModal] = useState(false);
  const [pagePositives, setPagePositives] = useState([]);
  const [pageNegatives, setPageNegatives] = useState([]);
  const [pageSoWhat, setPageSoWhat] = useState([]);
  const [portfolioComposition, setPortfolioComposition] = useState([]);
  const [featuresAndDifferentiators, setFeaturesAndDifferentiators] = useState(
    []
  );
  const [performanceAndAdoption, setPerformanceAndAdoption] = useState([]);
  const [patentPortfolio, setPatentPortfolio] = useState([]);
  const [
    patentLicensingAndCollaborations,
    setPatentLicensingAndCollaborations,
  ] = useState([]);
  const [launchTimelinesAndRegions, setLaunchTimelinesAndRegions] = useState(
    []
  );
  const [adoptionAndMarketResponse, setAdoptionAndMarketResponse] = useState(
    []
  );

  const dispatch = useDispatch();

  const { loading, data, error } = useSelector(
    (state) => state.corporateAndOrgStructureReducer
  );

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    dispatch(
      submitCorporateAndOrgStructureRequest("Product & Innovation Benchmarking", clientName)
    );
  }, []);

  useEffect(() => {
    const tempPortfolioComposition = getAllSubdimensionMatches(
      data,
      "Portfolio Composition"
    );
    setPortfolioComposition(tempPortfolioComposition);

    const tempFeaturesAndDifferentiators = getAllSubdimensionMatches(
      data,
      "Features & Differentiators"
    );
    setFeaturesAndDifferentiators(tempFeaturesAndDifferentiators);

    const tempPerformanceAndAdoption = getAllSubdimensionMatches(
      data,
      "Performance & Adoption"
    );
    setPerformanceAndAdoption(tempPerformanceAndAdoption);

    const tempPatentPortfolio = getAllSubdimensionMatches(
      data,
      "Patent Portfolio"
    );
    setPatentPortfolio(tempPatentPortfolio);

    const tempPatentLicensingAndCollaborations = getAllSubdimensionMatches(
      data,
      "Patent Licensing & Collaborations"
    );
    setPatentLicensingAndCollaborations(tempPatentLicensingAndCollaborations);

    const tempLaunchTimelinesAndRegions = getAllSubdimensionMatches(
      data,
      "Launch Timelines & Regions"
    );
    setLaunchTimelinesAndRegions(tempLaunchTimelinesAndRegions);

    const tempAdoptionAndMarketResponse = getAllSubdimensionMatches(
      data,
      "Adoption & Market Response"
    );
    setAdoptionAndMarketResponse(tempAdoptionAndMarketResponse);

    const { positive, negative, sowhat } = getAllPageInsights(data);
    setPagePositives(positive || []);
    setPageNegatives(negative || []);
    setPageSoWhat(sowhat || []);
  }, [data]);

  const handleAiConversation = () => console.log("AI conversation clicked");
  const handleDownload = () => console.log("Download clicked");

  const actions = [
    {
      type: "conversation",
      title: "Conversation",
      onClick: () => {
        setShowConversationModal((prev) => !prev);
      },
    },
    { type: "download", title: "Download", onClick: handleDownload },
  ];

  return (
    <div>
      <div className="product_innovations_wrapper">
        {loading ? (
          <GenericTableSkeleton colCount={3} rowCount={5} />
        ) : (
          <InsightBlock
            title={"Product & Innovation Benchmarking"}
            overview={`Comparative view of ${
              clientName ?? "HB Fuller"
            }’s innovation bets, product portfolio depth, IP strength, and R&D priorities benchmarked against Henkel, Bostik, and other top competitors.`}
            actions={actions}
            pagePositives={pagePositives}
            pageNegatives={pageNegatives}
            pageSoWhat={pageSoWhat}
          />
        )}

        {loading ? (
          <GenericTableSkeleton colCount={3} rowCount={5} />
        ) : (
          <PortfolioComposition portfolioComposition={portfolioComposition} />
        )}

        {loading ? (
          <GenericTableSkeleton colCount={3} rowCount={5} />
        ) : (
          <FeaturesDifferentiators
            featuresAndDifferentiators={featuresAndDifferentiators}
          />
        )}

        {loading ? (
          <GenericTableSkeleton colCount={3} rowCount={5} />
        ) : (
          <PerformanceAdoption
            performanceAndAdoption={performanceAndAdoption}
          />
        )}

        {loading ? (
          <GenericTableSkeleton colCount={3} rowCount={5} />
        ) : (
          <PatentPortfolio patentPortfolio={patentPortfolio} />
        )}

        {loading ? (
          <GenericTableSkeleton colCount={3} rowCount={5} />
        ) : (
          <PatentLicensingCollaborations
            patentLicensingAndCollaborations={patentLicensingAndCollaborations}
          />
        )}

        {loading ? (
          <GenericTableSkeleton colCount={3} rowCount={5} />
        ) : (
          <LaunchTimelinesRegions
            launchTimelinesAndRegions={launchTimelinesAndRegions}
          />
        )}

        {loading ? (
          <GenericTableSkeleton colCount={3} rowCount={5} />
        ) : (
          <AdoptionMarketResponse
            adoptionAndMarketResponse={adoptionAndMarketResponse}
          />
        )}
      </div>

      {showConversationModal && (
        <GenericOverviewSideCard
          showMoreModal={showConversationModal}
          setShowMoreModal={setShowConversationModal}
          titleForSideCard={
            <div className="ai_insight_top_block">
              <div className="ai_insight_left">
                <div className="ai_insight_img">
                  <img
                    src="/img/ai_insight_top.png"
                    alt="icon"
                    className="ai_icon"
                  />
                </div>
                <div className="ai_insight_text">
                  <h5 className="ai_insight_top_head">
                    Decode This:{" "}
                    {competitorName ?? "Tailored Chemical Products"} - Market
                    Insights
                  </h5>
                  <p className="ai_insight_top_subhead">
                    AI-powered competitive intelligence and strategic insights
                  </p>
                </div>
              </div>
              <div className="ai_insight_right"></div>
            </div>
          }
          comp={<AIChat section={""} />}
          minWidthForDrawer="40%"
          disableXbtn={false}
        />
      )}
    </div>
  );
}

export default ProductInnovations;
